// FastAPI 422 returns `detail` as an array of objects — rendering that directly crashes React.
export const formatApiError = (error, fallback = 'Something went wrong. Please try again.') => {
  const detail = error?.response?.data?.detail;
  if (detail == null) return error?.message || fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(' ') || fallback;
  }
  if (typeof detail.msg === 'string') return detail.msg;
  return fallback;
};
